import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import './assets/styles/index.css'
import moment from 'moment'
import VueCurrencyFilter from 'vue-currency-filter'
require('moment/locale/es')

Vue.use(require('vue-moment'), { moment })
Vue.use(VueCurrencyFilter, { symbol: '$', thousandsSeparator: ',', fractionSeparator: '.', fractionCount: 2 })

Vue.prototype.$http = Axios
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
